import { useTheme } from '@shopify/restyle';
import { Column } from 'app/design/primitives/box';
import { Page } from 'app/design/primitives/page';
import { Placeholder, PlaceholderLine, ShineOverlay } from 'app/overrides/rn-placeholder';
import type { Theme } from 'app/shopify';

export function PromoPagePlaceholder() {
  const theme = useTheme<Theme>();

  return (
    <Page>
      <Column gap="spacing.general.x4" paddingHorizontal="spacing.general.x8">
        <Placeholder Animation={ShineOverlay}>
          <PlaceholderLine height={74} />
          <PlaceholderLine style={{ borderRadius: 20, padding: theme.spacing['spacing.general.x12'] }} />
          <PlaceholderLine height={40} style={{ borderRadius: 20, marginTop: theme.spacing['spacing.general.x8'] }} />
        </Placeholder>
      </Column>
    </Page>
  );
}
